module.exports = __webpack_public_path__ + "static/img/z4.8796c6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/z4.png
// module id = gQb1
// module chunks = 0